import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "src/app/services/common.service";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.scss"],
})
export class ChangePasswordComponent implements OnInit {
  constructor(
    private _common: CommonService,
    private fb: FormBuilder,
    private location: Location
  ) {}

  passForm: FormGroup;
  submitted: boolean = false;
  showPassword: boolean = false;
  apiResponse: boolean = false;
  alertClass: string;
  alertText: string;

  ngOnInit(): void {
    this.passForm = this.fb.group({
      currentPassword: ["", [Validators.required, Validators.minLength(5)]],
      newPassword: ["", [Validators.required, Validators.minLength(5)]],
    });
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.passForm.valid) {
      this._common
        .post(`v1/changePassword`, this.passForm.getRawValue())
        .subscribe((resp: any) => {
          if (resp.status == 401) {
            this.alertClass = "error";
          } else if (resp.status == 200) {
            this.alertClass = "success";
            this.submitted = false;
            this.passForm.reset();
          }
          this.alertText = resp.message;
          this.apiResponse = true;
        });
    }
  }

  backLink() {
    this.location.back();
  }
}